import styled from 'styled-components';

interface HeaderLogoProps {
	compact?: boolean;
}

const HeaderLogo = styled.div<HeaderLogoProps>`
	width: ${({ compact }) => (compact ? '40px' : '48px')};
	height: ${({ compact }) => (compact ? '40px' : '48px')};
	display: flex;
	flex: 0 0 auto;
	align-items: center;
	background: url(${require('../../assets/images/logo.png')});
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 18%;
	overflow: hidden;
	margin-right: 35px;
`;

export default HeaderLogo;
